import React from "react";
import BlueChatWidget from "components/BlueChatWidget";

const WidgetPage = () => {
  return (
    <div className="min-h-screen bg-transparent">
      <BlueChatWidget isEmbedded={true} />
    </div>
  );
};

export default WidgetPage;
